var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title-container" }, [
      _c("h2", { staticClass: "search-title" }, [
        _vm._v(_vm._s(_vm.searchboxheadlineflighthelp[_vm.getCurrentLocale])),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm.searchboxheadlineflights2[_vm.getCurrentLocale])),
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "soap-icon-message" }),
    ]),
    _vm._v(" "),
    _c(
      "section",
      {
        staticStyle: { "padding-top": "20px", "background-color": "#fff" },
        attrs: { id: "content" },
      },
      [
        _c("div", { attrs: { id: "main" } }, [
          _c(
            "div",
            {
              staticClass: "contact-address block",
              staticStyle: { "margin-left": "20px", "margin-right": "20px" },
            },
            [
              _c("h4", { staticClass: "skin-color" }, [
                _vm._v(_vm._s(_vm.hellotext1[_vm.getCurrentLocale])),
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.hellotext2[_vm.getCurrentLocale]),
                },
              }),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "icon-box style5" }, [
                    _c("i", { staticClass: "soap-icon-phone" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _c("small", [
                        _vm._v(_vm._s(_vm.weareon[_vm.getCurrentLocale])),
                      ]),
                      _vm._v(" "),
                      _c("h5", [_vm._v("Tel. +49 (0) 30 - 53 676 791")]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "icon-box style5" }, [
                    _c("i", { staticClass: "soap-icon-message" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _c("small", [
                        _vm._v(_vm._s(_vm.sendusemail[_vm.getCurrentLocale])),
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "icon-box style5" }, [
                    _c("i", { staticClass: "soap-icon-address" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _c("small", [
                        _vm._v(_vm._s(_vm.meetusat[_vm.getCurrentLocale])),
                      ]),
                      _vm._v(" "),
                      _c("h5", [
                        _vm._v("SUNDAIR GmbH, Knieperdamm 79, 18435 Stralsund"),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", [
      _c("a", { attrs: { href: "mailto:kundenservice@sundair.com" } }, [
        _vm._v("kundenservice@sundair.com"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }